import { useTheme } from "../lib/theme";

/**
 * Theme toggle pill — no labels, no icons.
 *
 * - Light mode: pale blue track, white circle on the LEFT
 * - Dark mode:  same pale blue track, white circle on the RIGHT
 *
 * The circle slides on click. Compact size (~40x22px) to fit in headers
 * next to other controls without dominating the layout.
 */
export function ThemeToggle({ className }: { className?: string }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
      onClick={toggle}
      className={`relative inline-flex items-center w-10 h-[22px] rounded-full transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-accent/40 ${
        isDark ? "bg-[#7e95d8]" : "bg-[#c5d3ee]"
      } ${className ?? ""}`}
    >
      <span
        className={`absolute top-[2px] inline-block w-[18px] h-[18px] rounded-full shadow-sm transition-transform duration-150 ${
          isDark ? "translate-x-[20px]" : "translate-x-[2px]"
        }`}
        style={{ backgroundColor: "#ffffff" }}
      />
    </button>
  );
}
